import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, Stack, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
const CompareEmptyPage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { root } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    return (_jsx(Box, { paddingBlock: { base: '14', md: '32' }, children: _jsxs(Stack, { direction: "col", justify: "around", align: !isMobile ? 'center' : 'start', children: [_jsx(TextAlpha, { variant: "bodyL", children: t('compare.empty.nothing.added') }), _jsx(Box, { paddingBlockStart: "4", children: _jsx(Button, { fill: isMobile, href: `${root}lister.html`, text: t('compare.empty.add.products') }) })] }) }));
};
export { CompareEmptyPage };
